module.exports = __webpack_public_path__ + "static/sport/slide3.af599da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide3.png
// module id = K8hi
// module chunks = 0